// @flow

/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';
import Skeleton from '@ta/styleguide.skeleton';
import styles from './IntroBlockLoadingSkeleton.less';

const IntroBlockLoadingSkeleton = () => (
  <div className={`ui_card section ${styles.container}`}>
    <div className={styles.avatar_cutout} />
    <div className={styles.avatar_vertical_bar} />
    <div className={styles.avatar_horizontal_bar} />
    <div className={styles.line_one_cutout} />
    <div className={styles.line_two_cutout} />
    <div className={styles.line_three_cutout} />
    <div className={styles.line_four_cutout} />
    <div className={styles.line_five_cutout} />
    <div className={styles.background}>
      <Skeleton height="100%" />
    </div>
  </div>
);

export default IntroBlockLoadingSkeleton;
